import type { PostAccessUserBody } from '@bruce/api/api/access/user/body'
import type { CityId } from '@bruce/api/common/city'
import { z } from 'zod'
import { STRINGS } from '$lib/constants/strings'
import type { Language } from '@bruce/components'

export const schema = (lang: Language) => {
  return z.object({
    code: z.string().optional(),
    email: z.string().email(STRINGS[lang].SIGNUP_EMAIL_INVALID),
    first_name: z
      .string()
      .trim()
      .min(1, STRINGS[lang].SIGNUP_FIRST_NAME_REQUIRED),
    last_name: z
      .string()
      .trim()
      .min(1, STRINGS[lang].SIGNUP_LAST_NAME_REQUIRED),
    password: z.string().min(8, STRINGS[lang].SIGNUP_PASSWORD_MIN_LENGTH),
    city_id: z.preprocess(
      (value) => parseInt(value as string, 10),
      z.number(),
    ) as z.ZodType<CityId>,
    marketing_opt_in: z.preprocess(
      (value) => (value ? Boolean(value) : false),
      z.boolean().optional(),
    ) as z.ZodType<boolean>,
    'cf-turnstile-response': z.string(),
  }) satisfies z.ZodType<PostAccessUserBody>
}

export type FormInput = z.input<ReturnType<typeof schema>>
export type FormOutput = z.output<ReturnType<typeof schema>>
